export default function Sass_mixin() {
  return (
    <div>
      <h1>Sass @mixin</h1>
    </div>
  );
}
